import React from "react";
import NextImage from "next/image";

import BenefitsSection from "./BenefitsSection";

import { HeroSectionDataI } from "../shyftPassMaps";

const HeroSection = (props: HeroSectionDataI | any) => {
  const { title_1, title_2, title_3, ctaTitle } = props || {};

  const { bg_image } = props.card_data || {};

  return (
    <div id="shyft-pass-home" className="hero-section-wrapper">
      <div className="hero-container container">
        <div className="title-and-card-section">
          <div className="heading-section">
            <h1 style={{ display: "none" }}>
              Shyft Pass The Ultimate Health And Wellness Membership
            </h1>
            <h2 className="title">{title_1}</h2>
            <h2 className="title">{title_2}</h2>
            <h2 className="title">{title_3}</h2>
          </div>
          <div className="card-wrapper">
            <div className="card-section">
              <NextImage
                className="bg-image"
                alt="shyft-pass-card"
                src={bg_image}
                fill={true}
                priority
              />
            </div>
          </div>
        </div>
        <div className="sub-title-and-cta-section">
          <div className="description-section">
            {/* <p className="location-text">FOR GURGAON</p> */}
            <h3 className="description-title">
              The ultimate health & wellness membership!
            </h3>
          </div>
          <BenefitsSection ctaTitle={ctaTitle} />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
